/** Parse only explicitly registered callbacks. Never log or persist callback URLs. */
export interface CallbackCredentials {
  access_token: string;
  refresh_token: string;
}
export type CallbackResult =
  | { kind: "none" }
  | { kind: "invalid" }
  | { kind: "credentials"; credentials: CallbackCredentials };
export function parseAuthCallback(
  rawUrl: string | null,
  target: { platform: "web"; origin: string } | { platform: "native" },
): CallbackResult {
  if (!rawUrl) return { kind: "none" };
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return { kind: "invalid" };
  }
  const registered =
    target.platform === "native"
      ? url.protocol === "avalon:" &&
        url.hostname === "auth" &&
        url.pathname === "/callback"
      : url.origin === target.origin &&
        ["http:", "https:"].includes(url.protocol) &&
        url.pathname === "/auth/callback";
  if (
    !registered ||
    url.username ||
    url.password ||
    (target.platform === "native" && url.port)
  )
    return { kind: "none" };
  if (rawUrl.length > 16000 || url.search) return { kind: "invalid" };
  const fields = new URLSearchParams(url.hash.slice(1));
  if (fields.has("error") || fields.has("error_code"))
    return { kind: "invalid" };
  const access = fields.getAll("access_token");
  const refresh = fields.getAll("refresh_token");
  if (
    access.length !== 1 ||
    refresh.length !== 1 ||
    !access[0] ||
    !refresh[0] ||
    /\s/.test(access[0] + refresh[0]) ||
    (fields.has("token_type") && fields.get("token_type") !== "bearer")
  )
    return { kind: "invalid" };
  return {
    kind: "credentials",
    credentials: { access_token: access[0], refresh_token: refresh[0] },
  };
}
